// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { selectValue } from "#/admin/legacy/sp-select/index.js";

/** Returns the telephone dialog's template data, with the number's workflow resolved to a listed workflow. */
export function telephoneDialogData(numberData, { callTrackingInitialized, workflowItems }) {
  const data = {
    callTrackingInitialized,
    workflowItems,
    ...numberData,
  };

  data.workflow_id = selectValue(workflowItems, numberData.workflow_id);

  return data;
}
